<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Sentenance" open>
      <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/report'" index="2" icon="description">
        Report
      </vs-sidebar-item>

      <vs-sidebar-group title="Factory" open>
        <vs-sidebar-group title="Q-CON 1" open>
          <vs-sidebar-item
            :to="'/Factory/Machinelist/04Cutting'"
            icon="corporate_fare"
          >
            04 Cutting
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Q-CON 2"> </vs-sidebar-group>
        <vs-sidebar-group title="Q-CON 3"> </vs-sidebar-group>
      </vs-sidebar-group>
      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Setting">
        <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
          Network
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer">
      <div class="footer-sidebar center">
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="@/assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
    </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>